import { Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import * as echarts from 'echarts';
import { formatThousandth } from '../../../../utils/common';



@Component({
  selector: 'work-shop-acquisition',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less']
})
  
export class DealerWorkshopAcquisitionComponent implements OnInit, OnDestroy, OnChanges {
    @Input() data!: any;
    constructor() { }
    
    //  customer expansion split methods
    CustomerExpansionSplitMethods: any = {
      "BY_YEAR": ["Q1","Q2","Q3","Q4"],
      "BY_QUARTER": ["Q1","Q2","Q3","Q4"],
      "BY_MONTH": ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    }
  
    // Init
    ngOnInit(): void {
      this.renderAcquisitionRatePie();
      this.renderAchievementTurnoverBar();
    }

    // Destroy
    ngOnDestroy(): void {
    }

    // change
    ngOnChanges(changes: SimpleChanges): void {
      // when  @Input() data change
      if (changes["data"]) {
        this.renderAcquisitionRatePie();
        this.renderAchievementTurnoverBar();
      }

    }
      // render Achievement Rate Bar
  renderAcquisitionRatePie(): void {
     const dom = document.getElementById('acquisitionRatePie')
    if(!dom) return
    var myChart = echarts.init(dom);
    // 绘制图表
    myChart.setOption({
      series: [
        {
          name: 'Acquisition Rate',
          type: 'pie',
          radius: ['80%', '92%'],
          label: {
            show: false,
            position: 'center'
          },
          labelLine: {
            show: false
          },
          data: [
            {
              value: this.data.actualCustomer, 
              name: 'Target Customer',
              itemStyle: {
                color: "#007BC0"
              }
            },
            {
              value:this.data.targetCustomer - this.data.actualCustomer,
              name: 'Actual Customer',
              itemStyle: {
                color: "#C0DAEA"
              }
            },
          ]
        }
      ]
    });
  }
  formatNumber(number: number | string ): void {
    return formatThousandth(number || 0)
  }
  //render Achievement Turnover Bar
  renderAchievementTurnoverBar(): void {
    let targetSplitItems = this.data.expandCustomerItems;
    interface Series {
      targetCustomer: any;
      actualCustomer: any;
      xAxis: any;
    }
    let seriesData: Series = {
      targetCustomer: [],
      actualCustomer: [],
      xAxis: []
    }
    const dom = document.getElementById('acquisitionChart')
    if(!dom) return
    var myChart = echarts.init(dom);
    targetSplitItems?.forEach((item: any) => {
      seriesData.actualCustomer.push(item.actualCustomer || 0)
      seriesData.targetCustomer.push(item.targetCustomer || 0)
      seriesData.xAxis.push(this.CustomerExpansionSplitMethods[this.data.expandCustomerSplitMethod ||
        'BY_MONTH'][item.serialNo-1])
    })

    let options = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        formatter: (params: any) => {
          
          const titleStyle = "color:#1F1F1F;font-weight:600;margin-bottom:4px;display:flex;justify-content:space-between;align-items:center;"
          const itemStyle = "color:#71767C;margin-bottom:4px;display:flex;justify-content:space-between;align-items:center;"
          const spanStyle = "color:#142743;margin-left:30px;font-weight:600;"
          const rectStyle = "width:12px;height:12px;display:inline-block;margin-right:5px;"
          const target = targetSplitItems[params[0].dataIndex]['targetCustomer']
          const actual = targetSplitItems[params[0].dataIndex]['actualCustomer']
          return `<div style="font-size: 13px;">
            <div style=${titleStyle}>${params[0].axisValueLabel}</div>
            <div style=${titleStyle}>
              Act. vs. Target %
              <span style=${spanStyle}>${(target === 0 ? 0 :( actual / target)*100)?.toFixed(2)}%</span>
            </div>
            <div style=${itemStyle}>
              <div>
                <span style=${rectStyle + 'background:#007BC0'}></span>
                Actual Turnover (2024)
              </div>
              <span style=${spanStyle}>${formatThousandth(actual)}</span>
            </div>
            <div style=${itemStyle}>
              <div>
                <span style=${rectStyle + 'background:#C0DAEA'}></span>
                Target Turnover (2024)
              </div>
              <span style=${spanStyle}>${formatThousandth(target)}</span>
            </div>
          </div>`
        },
      },
      legend: {
        bottom: 0,
        icon: 'rect',
        selectedMode: false
      },
      grid: {
        left: '3%',
        right: '4%',
        top: '4%',
        bottom: '13%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          data: seriesData.xAxis
        }
      ],
      yAxis: [
        {
          type: 'value',
          step: 5000,
          axisLabel: {
              formatter: function(value: any) {
                  return `${(value/1000)} K`;
              }
          }
        }
      ],
      series: [
        {
          name: 'Actual Turnover (2024)',
          type: 'bar',
          barWidth: 20,
          stack: '2024',
          emphasis: {
            focus: 'series'
          },
          itemStyle: {
            color: "#007BC0"
          },
          data: seriesData.actualCustomer
        },
        {
          name: 'Target Turnover (2024)',
          type: 'bar',
          barWidth: 20,
          stack: '2024',
          emphasis: {
            focus: 'series'
          },
          itemStyle: {
            color: "#C0DAEA"
          },
          data: seriesData.targetCustomer
        }
      ]
    };
    myChart.setOption(options);
  }
}